export default {"src":"/_next/static/media/notes.19dac020.svg","height":381,"width":371};